import { render, staticRenderFns } from "./wxPublicNum.vue?vue&type=template&id=26cfcef5&scoped=true&"
import script from "./wxPublicNum.vue?vue&type=script&lang=js&"
export * from "./wxPublicNum.vue?vue&type=script&lang=js&"
import style0 from "./wxPublicNum.vue?vue&type=style&index=0&id=26cfcef5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cfcef5",
  null
  
)

export default component.exports